import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import './css/CustomField.css';
import IconButton from '@mui/material/IconButton';

import ClearIcon from '@mui/icons-material/Clear';
import { toast } from "react-toastify";
import api from "../config/backend";
import axios from "axios"
import { BiPlusCircle } from 'react-icons/bi';
import { Close } from '@mui/icons-material';
import { Grid } from '@mui/material';




const CustomField = ({ setTriggerRefresh }) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [fieldName, setFieldName] = useState('');
    const [fieldType, setFieldType] = useState(undefined);
    const [fieldError, setFieldError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [customOptions, setCustomOptions] = useState([]);
    const [newOption, setNewOption] = useState('');
    const [label, setLabel] = useState(undefined)
    const [placeholder, setPlaceholder] = useState(undefined)

    const token = localStorage.getItem("_crm__token")

    const handleOpenDialog = () => {
        setIsDialogOpen(true);
        setFieldName('');
        setFieldType('');
        setCustomOptions([]);
        setNewOption('');
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
    };

    const handleSave = async () => {
        // Create custom field
        const { data, status } = await axios.post(`${api}/Form/create-custom`, { token, fieldname: fieldName, label, placeholder, fieldtype: fieldType, options: customOptions })

        if (data.success) {
            toast.success(data.message)
            setTriggerRefresh(prev => prev + 1)
            handleCloseDialog()
        } else {
            toast.error(data.message)
        }
    };

    const handleOptionChange = () => {
        if (newOption) {
            setCustomOptions([...customOptions, newOption]);
            setNewOption('');
        }
    };
    const handleOptionRemove = (index) => {
        const updatedOptions = [...customOptions];
        updatedOptions.splice(index, 1);
        setCustomOptions(updatedOptions);
    };


    return (
        <div>
            <div className='app-modal-custom-fields__button'>
                <Button className='app-btn-text' onClick={handleOpenDialog}><BiPlusCircle/> Add a custom field</Button>
            </div>
            <div className='app-modal-custom-fields'>
                
            </div>
            <Dialog className='app-dialog-addlead app-dialog-customfields' open={isDialogOpen} onClose={handleCloseDialog}>
                <DialogTitle sx={{ m: 0, p: 2 }}> Add a custom field</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
                <DialogContent dividers>
                    <Grid container spacing={(3, 2)}>
                        <Grid item md={6}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Field Name"
                                value={fieldName}
                                onChange={(e) => setFieldName(e.target.value)}
                                required
                                error={!!fieldError}
                                helperText={fieldError}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <FormControl fullWidth variant="outlined">
                                <Select
                                    id="fieldType"
                                    value={fieldType}
                                    onChange={(e) => setFieldType(e.target.value)}
                                    displayEmpty
                                    required
                                >
                                    <MenuItem value="" disabled>
                                        Field Type
                                    </MenuItem>
                                    <MenuItem value="input">Input</MenuItem>
                                    <MenuItem value="textbox">Textbox</MenuItem>
                                    <MenuItem value="select">Select</MenuItem>
                                    <MenuItem value="rating">Rating</MenuItem>
                                </Select>
                                {typeError && (
                                    <div className="error-text">{typeError}</div>
                                )}
                            </FormControl>
                        </Grid>
                    </Grid>
               
                    {fieldType === "input" && (
                        <Grid style={{marginTop: "5px"}} container spacing={(3, 2)}>
                            <Grid item md={6}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Label"
                                    value={label}
                                    onChange={(e) => setLabel(e.target.value)}
                                    required
                                    error={!!fieldError}
                                    helperText={fieldError}
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Placeholder"
                                    value={placeholder}
                                    onChange={(e) => setPlaceholder(e.target.value)}
                                    required
                                    error={!!fieldError}
                                    helperText={fieldError}
                                />
                            </Grid>
                        </Grid>
                    )}
                    {(fieldType === "textbox" || fieldType === "rating") && (
                        <Grid style={{marginTop: "5px"}} container spacing={(3, 2)}>
                            <Grid item md={12}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Label"
                                    value={label}
                                    onChange={(e) => setLabel(e.target.value)}
                                    required
                                    error={!!fieldError}
                                    helperText={fieldError}
                                />
                            </Grid>
                        </Grid>
                    )}
                    {fieldType === 'select' && (
                        <Grid container spacing={2} style={{ marginTop: "5px" }}>
                            <Grid item md="12">
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Label"
                                    value={label}
                                    onChange={(e) => setLabel(e.target.value)}
                                    required
                                    error={!!fieldError}
                                    helperText={fieldError}
                                />
                            </Grid>
                            <Grid item md="12">
                                <div className='app-dialog-customfields__options'>
                                    {customOptions.map((option, index) => (
                                        <div key={index} className='app-dialog-customfields__options--item'>
                                            <span>{option}</span>
                                            <IconButton
                                                onClick={() => handleOptionRemove(index)}
                                                size="small"
                                                style={{ marginLeft: '8px' }}
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </div>
                                    ))}
                                </div>
                            </Grid>
                            <Grid item md="12">
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Option value"
                                        value={newOption}
                                        onChange={(e) => setNewOption(e.target.value)}
                                    />
                                    <Button
                                        onClick={handleOptionChange}
                                        style={{ marginLeft: '8px', fontSize: '20px', color: '#3f8854' }}
                                    >
                                        +
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button className='app-btn-text' onClick={handleCloseDialog} color="primary">
                        Cancel
                    </Button>
                    <Button className='app-btn-contained app-btn-primary' variant='contained' onClick={handleSave}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CustomField;
